import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { AlertRuleAuditResponse } from '@/types/alertDetail';

/**
 * GET /api/v1/alerts/{id}/rule-audit
 *
 * Returns the Phase D fired/returned_none/exception/kind_deactivated
 * aggregates for this alert's rule + asset, broken down by transaction
 * kind. When `rows_available=false`, the SPA hides the entire section
 * (Phase D writers haven't begun emitting yet for this rule).
 */
export function useAlertRuleAudit(
  alertId: number | undefined,
): UseQueryResult<AlertRuleAuditResponse, Error> {
  return useQuery<AlertRuleAuditResponse, Error>({
    queryKey: ['alert', alertId, 'rule-audit'],
    enabled: alertId != null,
    queryFn: async () => {
      const resp = await api.get<AlertRuleAuditResponse>(
        `/alerts/${alertId}/rule-audit`,
      );
      return resp.data;
    },
  });
}
